import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
class CorporatesPageTransform {
  constructor() {
    "ngInject";
    // NOTE: name is used for (user roles)
    this.item = {
      title: "Corporate",
      state: "corporate",
      name: "corporate",
    };

    this.fields = [
      { title: "Name", name: "name", isSortable: true },
      { title: "City", name: "city" },
      { title: "Invoice Email", name: "invoice_email" },
    ];

    this.filters = [
      { name: "active", title: "Active", icon: "person", list: "active" },
      { name: "city", title: "City", icon: "location_city", resource: "City" },
      {
        name: "search",
        title: "Search",
        icon: "search",
        isSearch: true,
        resource: "Corporate",
        state: "corporate",
      },
    ];

    this.addOptions = {
      title: "Add New Corporate",
      icon: "add",
      fields: [
        {
          name: "name",
          title: "Name",
          type: "text",
          isText: true,
          isRequired: true,
        },
        {
          resource: "City",
          name: "city",
          title: "City",
          isResource: true,
          isRequired: true,
        },
        {
          name: "invoice_email",
          title: "Mail Address",
          type: "email",
          isText: true,
          isRequired: true,
        },
        {
          name: "account_managers",
          title: "Account Managers",
          isResourceList: true,
          hasFormatter: true,
          items: [],
          resource: "User",
          isRequired: true,
        },
        {
          name: "office_locations",
          title: "Office Locations",
          items: [],
          isLocationsList: true,
          isRequired: true,
          hint: "Add office locations where employees need to commute to",
        },
        {
          name: "hotlines",
          title: "Hotlines",
          isItemsList: true,
          items: [],
          type: "number",
          hasFormatter: true,
          isRequired: false,
        },
        {
          name: "emails",
          title: "Email",
          isItemsList: true,
          items: [],
          type: "email",
          hasFormatter: true,
          isRequired: false,
        },
        {
          name: "numbers",
          title: "Numbers",
          isItemsList: true,
          items: [],
          type: "number",
          hasFormatter: true,
          isRequired: true,
        },
      ],
    };
  }

  justify(data) {
    const getSource = (item) => assign({ _id: item._id }, item._source);

    return map(getSource)(data);
  }
}

export default CorporatesPageTransform;



// WEBPACK FOOTER //
// ./src/pages/corporates/corporates.transforms.js